import React from 'react';
import { toState } from '../../base/redux/functions';
import { isWelcomePageEnabled } from '../../welcome/functions';
import { _sendReadyToClose } from '../external-api/functions';
import { getMobileRootRoute } from './initialRoute';
export const rootNavigationRef = React.createRef();
/**
 * User defined navigation action included inside the reference to the container.
 *
 * @param {string} name - Destination name of the route that has been defined somewhere.
 * @param {Object} params - Params to pass to the destination route.
 * @param {Object} options - React Navigation 7 merge/pop behavior.
 * @returns {Function}
 */
export function navigateRoot(name, params, options) {
    const navigation = rootNavigationRef.current;
    if (!navigation) {
        return undefined;
    }
    const dynamicNavigation = navigation;
    // React Navigation 7's navigate pushes another copy of a screen that is
    // already in the stack; 6 went back to it, and every caller (tab bars,
    // Back buttons) was written for that. pop restores it unless a caller
    // passes pop: false.
    return dynamicNavigation.navigate(name, params, { pop: true, ...options });
}
/**
 * Resets the root stack to a single route. Use this when leaving a conference
 * so Android cannot retain the Jitsi room underneath the app surface.
 *
 * @param {string} name - Destination name of the route that has been defined somewhere.
 * @param {Object} params - Params to pass to the destination route.
 * @returns {Function}
 */
export function resetRoot(name, params) {
    const navigation = rootNavigationRef.current;
    if (!navigation) {
        return undefined;
    }
    const dynamicNavigation = navigation;
    if (typeof dynamicNavigation.reset === 'function') {
        return dynamicNavigation.reset({
            index: 0,
            routes: [{
                    name,
                    params: params
                }]
        });
    }
    return navigateRoot(name, params);
}
/**
 * User defined navigation action included inside the reference to the container.
 *
 * @returns {Function}
 */
export function goBack() {
    return rootNavigationRef.current?.goBack();
}
/**
 * Navigates back to Welcome page, if it's available.
 *
 * @param {Object|Function} stateful - Either the whole Redux state object or the Redux store's {@code getState} method.
 * @param {Function} dispatch - Redux dispatch function.
 * @returns {void}
 */
export function goBackToRoot(stateful, dispatch) {
    const state = toState(stateful);
    if (isWelcomePageEnabled(state)) {
        resetRoot(getMobileRootRoute());
    }
    else {
        // For JitsiSDK, WelcomePage is not available
        _sendReadyToClose(dispatch);
    }
}
